const generateRandomString = seed => {
  seed = seed || 1;
  return Math.floor(
    Math.random() * Math.floor(Math.random() * Date.now() * seed)
  );
};

export { generateRandomString };
